import { GET_PINNED_VIEWS, GET_PINNED_VIEWS_FIELD_NAME, GET_VIEWS, GET_VIEWS_FIELD_NAME } from '../hooks/useFetchViews';
import { useDataFetchingClient } from 'data-fetching-client';
import { useCallback } from 'react';
import { useViewsNamespace } from '../hooks/useViewProps';
import useObjectTypeId from '../../hooks/useObjectTypeId';
export function updateViewsCache({
  cache,
  variables,
  updater
}) {
  /**
   * Update current cache with new views
   */
  const cachedData = cache.readQuery({
    query: GET_VIEWS,
    variables
  });
  if (!cachedData) {
    return;
  }
  cache.writeQuery({
    query: GET_VIEWS,
    data: {
      [GET_VIEWS_FIELD_NAME]: updater(cachedData.getViews)
    },
    variables
  });
}
export function useUpdateViewsCache() {
  const client = useDataFetchingClient();
  const namespace = useViewsNamespace();
  const objectTypeId = useObjectTypeId();
  return useCallback(updater => {
    updateViewsCache({
      cache: client.cache,
      variables: {
        namespace,
        objectType: objectTypeId
      },
      updater
    });
  }, [client.cache, namespace, objectTypeId]);
}
export function updatePinnedViewsCache({
  cache,
  variables,
  updater
}) {
  /**
   * Update current cache with new views
   */
  const cachedData = cache.readQuery({
    query: GET_PINNED_VIEWS,
    variables
  });
  if (!cachedData) {
    return;
  }
  cache.writeQuery({
    query: GET_PINNED_VIEWS,
    data: {
      [GET_PINNED_VIEWS_FIELD_NAME]: updater(cachedData.getPinnedViews)
    },
    variables
  });
}